import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions } from "../../../../../../../_helpers/Helpers";
import * as actions from "../../../../_redux/user-assignment/UserAssignmentAction";
import { useTeacherUsersUIContext } from "../TeacherUsersUIContext";

const prepareFilter = (queryParams, values) => {
  let { tcKimlikNo, name, surname, branchId } = values;
  const newQueryParams = { ...queryParams };
  const filter = { tcKimlikNo, name, surname, branchId };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function TeacherUsersFilter() {
  // Teacher Users UI Context
  const teacherUsersUIContext = useTeacherUsersUIContext();
  const teacherUsersUIProps = useMemo(() => {
    return {
      setQueryParams: teacherUsersUIContext.setQueryParams,
      queryParams: teacherUsersUIContext.queryParams,
    };
  }, [teacherUsersUIContext]);

  const dispatch = useDispatch();
  const { branches } = useSelector(
    (state) => ({
      branches: state.userAssignment.filters
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getBranches());
  }, [dispatch]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(teacherUsersUIProps.queryParams, values);
    if (!isEqual(newQueryParams, teacherUsersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      teacherUsersUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const branchOptions = FilterOptions.concat(branches);

  return (
    <Formik
      initialValues={{
        tcKimlikNo: "",
        name: "",
        surname: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="tcKimlikNo"
                placeholder="TC Kimlik No"
                onBlur={handleBlur}
                value={values.tcKimlikNo}
                onChange={(e) => {
                  setFieldValue("tcKimlikNo", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>TC Kimlik No</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={branchOptions}
                value={values.branchId}
                placeholder="Branşı"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("branchId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Branşı</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}